import { InjectionToken } from '@angular/core';

import { Config } from 'dompurify';

export const DOM_PURIFY_CONFIG = new InjectionToken<Config>('DOM_PURIFY_CONFIG');
